module.exports = __webpack_public_path__ + "static/media/nike2.121885c3.svg";